import { ApolloError } from '@apollo/client';
import React from 'react';
import styled from 'styled-components';
import { UnderlineButton } from '../../../Components/Buttons';
import { colors } from '../../../globalStyles';
import { Styles } from '../styles';

const isForbidden = (error: ApolloError) =>
  error.graphQLErrors.some(graphQLError => graphQLError.extensions?.code === 'FORBIDDEN');

export const BeaconQueryError = ({
  error,
  onRetry,
}: {
  error: ApolloError;
  onRetry: () => void;
}) => {
  if (isForbidden(error)) {
    return <Styles.widget role="alert">You don't have access to this view</Styles.widget>;
  }

  return (
    <Styles.widget role="alert">
      Unable to load the student's Beacon results.{' '}
      <RetryButton type="button" color={colors.link} onClick={onRetry}>
        Try again
      </RetryButton>
    </Styles.widget>
  );
};

const RetryButton = styled(UnderlineButton)`
  font-size: inherit;
`;
